import AxiosService from '../AxiosService';

const ExchangeProductRequest = async (formData: FormData): Promise<any> => {
  const instance = AxiosService.createAuthAxiosInstance();
  return instance.post('/v1/client/request/exchange', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const RequestExchangeProductList = async (): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/exchange?paged=0&canceled=0');
};

const UpdateExchangeProductRequestStatus = async (id: number|string, data: any): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .put(`/v1/client/request/exchange/${id}`, data);
}

export default {
  ExchangeProductRequest,
  RequestExchangeProductList,
  UpdateExchangeProductRequestStatus
};
